import { useMemo } from 'react';

import {
  BASE_FILL_IN_BLANKS_RICHTEXT_SETTINGS,
  FillInBlanksAnswer,
} from '../fill-in-blanks.constants';

export const useFillInBlanksRichtextSettings = (field: FillInBlanksAnswer) => {
  const settings = useMemo(() => {
    return {
      ...BASE_FILL_IN_BLANKS_RICHTEXT_SETTINGS,
      placeholder: !field.showPlaceholderAsScaffold
        ? field.placeholder || ''
        : undefined,
      readonlyPlaceholder: field.showPlaceholderAsScaffold
        ? field.placeholder || ''
        : undefined,
      canChangeBlockType: false,
      canChangeFonts: false,
      canAddLinks: false,
      canAlignText: false,
      handlePaste: (view: unknown, event: ClipboardEvent) => {
        // Prevent the default paste behavior
        event.preventDefault();

        // Get plain text from the clipboard
        const plainText = event.clipboardData?.getData('text/plain');

        if (plainText) {
          // Cast view to ProseMirror EditorView type
          const editorView = view as {
            dispatch: (tr: unknown) => void;
            state: {
              tr: {
                insertText: (text: string) => unknown;
              };
            };
          };

          // Insert the plain text using ProseMirror transaction
          const tr = editorView.state.tr.insertText(plainText);
          editorView.dispatch(tr);
        }

        return true; // Return true to indicate the paste was handled
      },
    };
  }, [field]);

  return settings;
};
